import { useParams } from "react-router-dom"
import { useTattooDetail } from "@/hooks/useTattooDetail"
import { useArtists } from "@/hooks/useArtists"
import { useDynamicMetaTags } from "@/hooks/useDynamicMetaTags"
import { formatArtistDisplayName } from "@/lib/utils"
import { useToast, Toast } from "@/components/ui/toast"
import { TattooDetailContent } from "@/components/details/TattooDetailContent"

export default function TattooDetailPage() {
  const { tattooId } = useParams<{ tattooId: string }>()
  const { tattoo } = useTattooDetail(tattooId)
  const { artists } = useArtists(tattoo ? [tattoo.artistId] : [])
  const { toast, hideToast } = useToast()

  const artist = artists[0]

  useDynamicMetaTags({
    title: tattoo && artist ? `${formatArtistDisplayName(artist) || artist.displayName} - Tattoo` : undefined,
    description: tattoo ? `Check out this tattoo` : undefined,
    image: tattoo?.imageUrl,
    url: tattoo ? `https://getmoretats.com/tattoos/${tattoo.id}` : undefined,
    type: 'article'
  })

  if (!tattooId) return null

  return (
    <>
      <div style={{ paddingBottom: 'var(--bottom-nav-offset)' }}>
        <TattooDetailContent tattooId={tattooId} />
      </div>
      <Toast {...toast} onClose={hideToast} />
    </>
  )
}

